import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=80d00076&scoped=true"
import script from "./CustomNav.vue?vue&type=script&lang=js"
export * from "./CustomNav.vue?vue&type=script&lang=js"
import style0 from "./CustomNav.vue?vue&type=style&index=0&id=80d00076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d00076",
  null
  
)

export default component.exports